Object.defineProperty(exports, "__esModule", { value: true });
const tokens_1 = require("../../tokens");
exports.EmeraldTheme = {
    name: 'emerald',
    appPrimaryColor: tokens_1.Emerald[100],
    appSecondaryColor: tokens_1.Grey[100],
    appFontFamily: tokens_1.Fonts.Titillium,
};
//# sourceMappingURL=EmeraldTheme.js.map